import { useState } from 'react'
import { Alert, Button, Container, Form } from 'react-bootstrap'
import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { HeaderTitle } from '../../common/HeaderTitle.jsx'
import { useZmienHaslo } from '../../../api/domain/osoby/mutations/useZmienHaslo.jsx'

const initialForm = {
    password_curr: '',
    password: '',
    password_confirmation: '',
}

const initialReveal = {
    password_curr: 'password',
    password: 'password',
    password_confirmation: 'password',
}

const fieldLabels = {
    password_curr: 'Obowiazujace haslo',
    password: 'Nowe haslo',
    password_confirmation: 'Powtorz nowe haslo',
}

const ViewZmianaHasla = () => {
    const role = useSelector((state) => state.user.role)
    const [form, setForm] = useState(initialForm)
    const [errors, setErrors] = useState({})
    const [reveal, setReveal] = useState(initialReveal)

    const zmienHaslo = useZmienHaslo(setErrors, () => {
        setForm(initialForm)
        setReveal(initialReveal)
    })

    if (role !== 'wp') {
        return <Navigate to='/' replace />
    }

    const updateField = (name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }))
        setErrors((prev) => ({
            ...prev,
            [name]: undefined,
            ...(name === 'password' || name === 'password_confirmation'
                ? { password_confirmation: undefined }
                : {}),
        }))
    }

    const toggleReveal = (name) => {
        setReveal((prev) => ({
            ...prev,
            [name]: prev[name] === 'password' ? 'text' : 'password',
        }))
    }

    const validateForm = () => {
        const nextErrors = {}

        if (!form.password_curr?.trim()) {
            nextErrors.password_curr = 'Pole jest wymagane.'
        }

        if (!form.password?.trim()) {
            nextErrors.password = 'Pole jest wymagane.'
        }

        if (!form.password_confirmation?.trim()) {
            nextErrors.password_confirmation = 'Pole jest wymagane.'
        } else if (form.password !== form.password_confirmation) {
            nextErrors.password_confirmation =
                'Podana wartosc w potwierdzeniu hasla musi byc taka sama.'
        }

        setErrors(nextErrors)
        return Object.keys(nextErrors).length === 0
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (!validateForm()) {
            return
        }

        zmienHaslo.mutate(form)
    }

    const renderPasswordField = (name) => (
        <Form.Group className='w-100 mb-3'>
            <Form.Label htmlFor={name} className='d-block text-start'>
                {fieldLabels[name]}
            </Form.Label>
            <div className='position-relative'>
                <Form.Control
                    id={name}
                    type={reveal[name]}
                    value={form[name]}
                    onChange={(event) => updateField(name, event.target.value)}
                    className='pe-5'
                />
                <Button
                    type='button'
                    variant='link'
                    title='Pokaz/ukryj haslo'
                    className='position-absolute top-50 end-0 translate-middle-y text-secondary p-0 me-3 border-0 shadow-none'
                    onClick={() => toggleReveal(name)}
                >
                    {reveal[name] === 'password' ? (
                        <RiEyeOffLine size={18} />
                    ) : (
                        <RiEyeLine size={18} />
                    )}
                </Button>
            </div>
            {errors?.[name] && (
                <Alert className='p-1 w-100 mt-1' variant='danger'>
                    <div className='ms-1'>{errors[name]}</div>
                </Alert>
            )}
        </Form.Group>
    )

    return (
        <>
            <HeaderTitle
                size={'h2'}
                nav={true}
                destination={'/'}
                title={'Zmiana hasla'}
            />
            <Container>
                <Form className='w-100' onSubmit={handleSubmit}>
                    <div className='w-100' style={{ maxWidth: '920px' }}>
                        {renderPasswordField('password_curr')}
                        {renderPasswordField('password')}
                        {renderPasswordField('password_confirmation')}
                        <Button
                            type='submit'
                            className='mt-2'
                            disabled={zmienHaslo.isPending}
                        >
                            Zmien haslo
                        </Button>
                    </div>
                </Form>
            </Container>
        </>
    )
}

export default ViewZmianaHasla
